import { useState, useCallback } from "react"

export function useCategorySelection(children) {
  const [selectedItems, setSelectedItems] = useState([])
  const [lastSelectedId, setLastSelectedId] = useState(null)

  const handleCardClick = useCallback(
    (e, childId) => {
      if (e.detail === 2) return

      if (e.shiftKey) {
        if (lastSelectedId && lastSelectedId !== childId) {
          const childIds = children.map((c) => c.id)
          const lastIndex = childIds.indexOf(lastSelectedId)
          const currentIndex = childIds.indexOf(childId)
          if (lastIndex !== -1 && currentIndex !== -1) {
            const start = Math.min(lastIndex, currentIndex)
            const end = Math.max(lastIndex, currentIndex)
            setSelectedItems((prev) =>
              Array.from(new Set([...prev, ...childIds.slice(start, end + 1)]))
            )
          } else {
            setSelectedItems((prev) =>
              prev.includes(childId) ? prev : [...prev, childId]
            )
          }
        } else {
          setSelectedItems((prev) =>
            prev.includes(childId) ? prev : [...prev, childId]
          )
        }
        setLastSelectedId(childId)
      } else if (e.metaKey || e.ctrlKey) {
        setSelectedItems((prev) =>
          prev.includes(childId) ? prev.filter((id) => id !== childId) : [...prev, childId]
        )
        setLastSelectedId(childId)
      } else {
        setSelectedItems((prev) =>
          prev.includes(childId) && prev.length === 1 ? [] : [childId]
        )
        setLastSelectedId(childId)
      }
    },
    [lastSelectedId, children]
  )

  const handleBackgroundClick = useCallback((e) => {
    if (
      e.target.classList.contains("taxonomy-grid") ||
      e.target.classList.contains("taxonomy-empty")
    )
      setSelectedItems([])
  }, [])

  return { selectedItems, setSelectedItems, handleCardClick, handleBackgroundClick }
}
